(function (root, factory) {
  'use strict';
  const api = factory(root);
  if (typeof module === 'object' && module.exports) module.exports = api;
  if (root?.document) {
    root.PinmeFreeShipping = api;
    if (!root.__pinmeFreeShippingEvents) {
      root.__pinmeFreeShippingEvents = true;
      const document = root.document;
      const currentCart = () => {
        if (root.PinmeCart) return root.PinmeCart.cart || null;
        try { return JSON.parse(document.querySelector('[data-pinme-cart-initial]')?.textContent || 'null'); } catch (_) { return null; }
      };
      const initial = () => api.render(document,currentCart());
      document.addEventListener('cart:update',event => api.render(document,event.detail?.resource || null));
      document.addEventListener('pinme:market-updated',event => api.render(document,event.detail?.cart || null));
      document.addEventListener('shopify:section:load',event => api.render(event.target,currentCart()));
      if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',initial,{once:true});
      else initial();
    }
  }
})(typeof window === 'undefined' ? null : window, function (root) {
  'use strict';
  const defaults = Object.freeze({
  "checkout": "Shipping calculated at checkout.",
  "empty": "Free shipping on orders {amount}+",
  "emptyUS": "Buy 2+ items, including a MUMUSE, for free U.S. shipping.",
  "one": "Add 1 more item for free U.S. shipping.",
  "mumuseRequired": "Add a MUMUSE item to qualify for free U.S. shipping.",
  "unlocked": "You've unlocked free shipping!",
  "unlockedUS": "Your order qualifies for free U.S. shipping.",
  "count": "items",
  "set": "Qualifying set",
  "amountRemaining": "Add {amount} more for free shipping.",
  "amountRemainingOrder": "You're {amount} away from free shipping.",
  "qualifiesOrder": "Your order qualifies for free shipping.",
  "announcementAmount": "Free shipping on orders {amount}+",
  "announcementUS": "Free U.S. shipping on 2+ items, including at least 1 MUMUSE",
  "productUS": "Free U.S. shipping on 2+ items, including at least 1 MUMUSE.",
  "productAmount": "Free shipping on orders {amount}+",
  "productFromAmount": "Shipping from {shipping}. Free on orders {amount}+.",
  "preorderUnknown": "Preorder · Shipping schedule to be confirmed.",
  "preorderDispatch": "Preorder · Estimated dispatch: {window}",
  "preorderTransit": "Estimated transit after dispatch: {days} {unit}.",
  "deliveryAtCheckout": "Delivery options and estimates are shown at checkout.",
  "deliveryUS": "Estimated delivery: {days} business days",
  "deliveryAsia": "Estimated delivery: about {days} business days",
  "deliveryCrossBorder": "Estimated delivery: {days} business days",
  "deliveryUSDetail": "{processing} {processingUnit} to process, plus {transit} in transit.",
  "deliveryAsiaDetail": "{processing} {processingUnit} to process, plus about {transit} in transit.",
  "deliveryCrossBorderDetail": "{processing} {processingUnit} to process, plus {transit} in transit.",
  "deliveryCalendar": "Estimated delivery: about {transit} calendar days after dispatch",
  "deliveryCalendarDetail": "Processed within {processing} {processingUnit}.",
  "calendarDays": "calendar days",
  "businessDay": "business day",
  "businessDays": "business days"
});
  const id = value => /^[1-9]\d*$/.test(String(value ?? '').trim()) ? String(value).trim() : '';
  const iso = value => typeof value === 'string' ? value.trim().toUpperCase() : '';
  const integer = value => typeof value === 'number' && Number.isSafeInteger(value) && value >= 0;
  const currencyOf = value => iso(typeof value === 'string' ? value : value?.iso_code);
  const supportedCurrencies = new Set(typeof Intl.supportedValuesOf === 'function' ? Intl.supportedValuesOf('currency') : ['USD','GBP','NZD','JPY','MYR','THB','HKD','CAD','AUD','EUR','SGD']);
  const orderCurrencies = Object.freeze({DE:'EUR',FR:'EUR',IT:'EUR',NL:'EUR',SG:'SGD'});
  const format = (text, values = {}) => String(text || '').replace(/\{([A-Za-z]+)\}/g,(match,key) => values[key] ?? match);
  function configuration(value) {
    if (value && typeof value === 'object') return value;
    if (root?.PinmeTheme?.config?.freeShipping) return root.PinmeTheme.config.freeShipping;
    try { return JSON.parse(root?.document?.getElementById('PinmeThemeConfig')?.textContent || '{}').freeShipping || {}; } catch (_) { return {}; }
  }
  function money(amount,currency,locale) {
    if (!integer(amount) || !/^[A-Z]{3}$/.test(currency)) return '';
    try {
      if (typeof root?.PinmeCart?.money === 'function') return root.PinmeCart.money(amount,currency);
      return new Intl.NumberFormat(locale || 'en-US',{style:'currency',currency}).format(amount/100);
    } catch (_) { return ''; }
  }
  function orderMoney(amount,currency,fixed = false) {
    if (!integer(amount) || !['EUR','SGD'].includes(currency)) return '';
    const decimals = fixed || amount % 100 !== 0 ? 2 : 0;
    return (currency === 'EUR' ? '€' : 'S$') + new Intl.NumberFormat('en-US',{minimumFractionDigits:decimals,maximumFractionDigits:2}).format(amount/100);
  }
  function unitRules(config) {
    const map = new Map();
    String(config.variantUnits ?? '').split(/[,\r\n]+/).forEach(entry => {
      const pair = entry.trim().split(':');
      if (pair.length !== 2 || !id(pair[0]) || !/^(?:0|[1-9]\d{0,2})$/.test(pair[1].trim())) return;
      const units = Number(pair[1]);
      if (units <= 100) map.set(id(pair[0]),units);
    });
    return map;
  }
  const variantId = item => id(item?.variant_id ?? item?.variant?.id ?? item?.variantId ?? item?.id);
  const parentKey = item => item?.parent_relationship?.parent_key || item?.parent_relationship?.parent?.key || '';
  function countUnits(cart,overrides,defaultUnits = 0) {
    const items = Array.isArray(cart?.items) ? cart.items : [],keyed = new Map();
    items.forEach(item => { if (typeof item?.key === 'string' && item.key) keyed.set(item.key,item); });
    const amount = item => item && item.gift_card !== true && item.requires_shipping !== false && integer(item.quantity) && item.quantity > 0 ? (overrides.has(variantId(item)) ? overrides.get(variantId(item)) : defaultUnits) : 0;
    let total = 0;
    const seen = new Set();
    for (const item of items) {
      const units = amount(item);
      if (!units || item.key && seen.has(item.key)) continue;
      if (item.key) seen.add(item.key);
      const ancestors = new Set();
      let key = parentKey(item),countedParent = false;
      while (key && !ancestors.has(key)) {
        ancestors.add(key);
        const parent = keyed.get(key);
        if (!parent || parent === item) break;
        if (amount(parent)) { countedParent = true; break; }
        key = parentKey(parent);
      }
      if (!countedParent) total = Math.min(Number.MAX_SAFE_INTEGER,total+units*item.quantity);
    }
    return total;
  }
  function hasMumuse(cart,config) {
    const productIds = new Set((config.mumuseProductIds || []).map(id).filter(Boolean));
    const variantIds = new Set((config.mumuseVariantIds || []).map(id).filter(Boolean));
    return (cart.items || []).some(item => {
      if (!item || typeof item !== 'object' || item.gift_card === true || item.requires_shipping === false || !integer(item.quantity) || item.quantity <= 0) return false;
      const productId = id(item.product_id ?? item.product?.id ?? item.productId);
      return productId ? productIds.has(productId) : variantIds.has(variantId(item));
    });
  }
  function delivery(config,labels,country,validMarket,context) {
    const current = context.product;
    const fallback = status => ({status,heading:labels.deliveryAtCheckout,detail:'',processingDays:null,transitMin:null,transitMax:null,showEstimate:false});
    if (!current || typeof current !== 'object') return fallback('unknown');
    const product = config.products?.[id(current.id ?? current.product_id)] || {};
    const variant = config.variants?.[id(current.variantId ?? current.variant_id)] || {};
    const resolved = {...product,...variant};
    for (const key of ['state','source','preorderWindow','usStock','japanChannelConfirmed']) {
      if (current[key] !== undefined && current[key] !== null && current[key] !== '') resolved[key] = current[key];
    }
    const state = resolved.state || (current.available === true ? 'stock' : current.available === false ? 'sold_out' : 'unknown');
    if (!validMarket) return fallback(state);
    let key;
    if (country === 'US') {
      if (resolved.source === 'us' || resolved.usStock === true) key = 'us';
    } else if (['JP','MY','TH','HK'].includes(country)) {
      if (country !== 'JP' || resolved.japanChannelConfirmed !== false) key = 'asia';
    } else if (['GB','CA','AU','NZ'].includes(country)) key = 'crossBorder';
    const baseRule = key ? config.delivery?.[country] || config.delivery?.[key] : null;
    const override = context.deliveryRule;
    const rule = baseRule ? {...baseRule} : null;
    if (rule && override && typeof override === 'object') {
      for (const field of ['processingDays','transitMin','transitMax']) if (integer(override[field])) rule[field] = override[field];
      rule.transitMax = Math.max(rule.transitMin,rule.transitMax);
    }
    const validRule = rule && integer(rule.processingDays) && integer(rule.transitMin) && integer(rule.transitMax) && rule.transitMin <= rule.transitMax && Number.isSafeInteger(rule.processingDays+rule.transitMax);
    const range = (min,max) => min === max ? String(min) : min+'–'+max;
    if (state === 'preorder' || state === 'coming_soon') {
      const window = typeof resolved.preorderWindow === 'string' ? resolved.preorderWindow.trim() : '';
      const result = fallback(state);
      result.heading = window ? format(labels.preorderDispatch,{window}) : labels.preorderUnknown;
      result.detail = window && validRule ? format(labels.preorderTransit,{days:range(rule.transitMin,rule.transitMax),unit:rule.transitUnit === 'calendar' ? labels.calendarDays : labels.businessDays}) : '';
      return result;
    }
    if (current.available !== true || state !== 'stock') return fallback(current.available === false ? 'sold_out' : state);
    if (!validRule) return fallback('stock');
    const suffix = key === 'us' ? 'US' : key === 'asia' ? 'Asia' : 'CrossBorder';
    const values = {days:range(rule.processingDays+rule.transitMin,rule.processingDays+rule.transitMax),processing:rule.processingDays,processingUnit:rule.processingDays === 1 ? labels.businessDay : labels.businessDays,transit:range(rule.transitMin,rule.transitMax)};
    return {status:'stock',heading:format(rule.transitUnit === 'calendar' ? labels.deliveryCalendar : labels['delivery'+suffix],values),detail:format(rule.transitUnit === 'calendar' ? labels.deliveryCalendarDetail : labels['delivery'+suffix+'Detail'],values),processingDays:rule.processingDays,transitMin:rule.transitMin,transitMax:rule.transitMax,transitUnit:rule.transitUnit || 'business',calendarRule:{...rule},showEstimate:true};
  }
  function evaluate(cart,value,context = {}) {
    const config = configuration(value),labels = {...defaults,...config.labels},country = iso(config.country),currency = currencyOf(config.currency);
    const market = /^[A-Z]{2}$/.test(country) ? config.markets?.[country] : null;
    const orderCurrency = orderCurrencies[country];
    const orderMarket = Boolean(orderCurrency && currency === orderCurrency);
    const validMarket = Boolean(market && supportedCurrencies.has(currency) && currency === currencyOf(market.currency) && (!orderCurrency || orderMarket) && (!cart || currencyOf(cart.currency) === currency));
    const thresholdValid = integer(market?.threshold) && market.threshold > 0;
    const quantityMarket = country === 'US';
    const quantityTarget = integer(market?.quantityTarget) && market.quantityTarget > 0 ? market.quantityTarget : null;
    const ruleValid = quantityMarket ? Boolean(quantityTarget) : thresholdValid;
    const units = countUnits(cart,unitRules(config),quantityMarket ? 1 : 0),total = cart?.total_price;
    const validCart = Boolean(cart && Array.isArray(cart.items) && integer(total));
    const active = Boolean(validMarket && market.enabled === true && ruleValid && validCart);
    const state = {active,units,set:false,unlocked:false,ratio:0,text:labels.checkout,count:'',country,currency,threshold:thresholdValid ? market.threshold : null,remaining:null,secondaryText:'',announcement:labels.checkout,announcementAmount:'',productText:labels.checkout,delivery:delivery(config,labels,country,validMarket,context)};
    if (!validMarket || market.enabled !== true || !ruleValid || cart && !validCart) return state;
    if (['US','CA','AU'].includes(country)) {
      const address = context.shippingAddress || context.shipping_address || cart?.shipping_address;
      const region = iso(address?.province_code);
      if (iso(address?.country_code) === country && market.excludedRegions?.includes(region)) return {...state,active:false};
    }
    if (quantityMarket) {
      state.threshold = null;
      state.quantityTarget = quantityTarget;
      state.announcement = labels.announcementUS;
      state.productText = labels.productUS;
      if (!validCart) return state;
      state.remainingUnits = Math.max(0,quantityTarget-units);
      state.hasMumuse = hasMumuse(cart,config);
      state.unlocked = units >= quantityTarget && state.hasMumuse;
      state.ratio = Math.min(units/quantityTarget,state.hasMumuse ? 1 : (quantityTarget-1)/quantityTarget);
      state.count = (units >= quantityTarget ? quantityTarget+'+' : units+' / '+quantityTarget)+' '+labels.count;
      state.text = state.unlocked ? labels.unlockedUS : units > 0 && !state.hasMumuse ? labels.mumuseRequired : units === quantityTarget-1 ? labels.one : labels.emptyUS;
      return state;
    }
    const thresholdMoney = orderMarket ? orderMoney(market.threshold,currency) : money(market.threshold,currency,config.locale);
    if (!thresholdMoney) return {...state,active:false};
    state.announcementAmount = thresholdMoney;
    state.announcement = country === 'US' ? labels.announcementUS : format(labels.announcementAmount,{amount:thresholdMoney});
    state.productText = orderMarket ? integer(market.shippingFrom) && market.shippingFrom > 0 ? format(labels.productFromAmount,{shipping:orderMoney(market.shippingFrom,currency,true),amount:thresholdMoney}) : labels.checkout : country === 'US' ? labels.productUS : format(labels.productAmount,{amount:thresholdMoney});
    if (!validCart) return state;
    const threshold = market.threshold;
    const hasItems = cart.items.some(item => integer(item?.quantity) && item.quantity > 0 && item.gift_card !== true && item.requires_shipping !== false);
    state.threshold = threshold;
    state.remaining = hasItems ? Math.max(0,threshold-total) : threshold;
    state.unlocked = hasItems && total >= threshold;
    state.ratio = hasItems ? Math.max(0,Math.min(total/threshold,1)) : 0;
    const displayedRemaining = currency === 'JPY' && state.remaining > 0 ? Math.ceil(state.remaining/100)*100 : state.remaining;
    const remainingMoney = orderMarket ? orderMoney(displayedRemaining,currency) : money(displayedRemaining,currency,config.locale);
    if (orderMarket) {
      state.text = state.unlocked ? labels.qualifiesOrder : format(labels.amountRemainingOrder,{amount:remainingMoney});
    } else if (state.unlocked) state.text = labels.unlocked;
    else state.text = format(hasItems ? labels.amountRemaining : labels.empty,{amount:hasItems ? remainingMoney : thresholdMoney});
    return state;
  }
  function render(element,cart,value,context = {}) {
    if (!element?.querySelectorAll) return;
    const state = evaluate(cart,value,context);
    element.querySelectorAll('[data-pinme-shipping-text]').forEach(node => { node.textContent = state.text; });
    element.querySelectorAll('[data-pinme-shipping-secondary]').forEach(node => { node.textContent = state.secondaryText; node.hidden = !state.secondaryText; });
    element.querySelectorAll('[data-pinme-shipping-count]').forEach(node => { node.textContent = state.count; node.hidden = !state.active || !state.count; });
    element.querySelectorAll('[data-pinme-shipping-bar]').forEach(node => { node.hidden = !state.active; });
    element.querySelectorAll('[data-pinme-shipping-progress]').forEach(node => {
      if (node.dataset.pinmeShippingProgress === 'scale') node.style.transform = 'scaleX('+state.ratio+')';
      else node.style.setProperty('--pinme-progress',state.ratio*100+'%');
    });
    element.querySelectorAll('[data-pinme-shipping-state]').forEach(node => { node.dataset.pinmeShippingState = !state.active ? 'inactive' : state.unlocked ? 'unlocked' : 'remaining'; });
    element.querySelectorAll('[data-pinme-shipping-announcement]').forEach(node => {
      const custom = String((state.country === 'US' ? node.dataset.pinmeAnnouncementUs : node.dataset.pinmeAnnouncementOther) || '').trim();
      const shippingPattern = state.country === 'US'
        ? /^(?:free\s+(?:u\.?s\.?\s+)?shipping\b|(?:buy|choose|add|get)\s+(?:any\s+)?(?:2|two)\s+(?:plushies|items)\b.*\bfree\s+(?:u\.?s\.?\s+)?shipping\b)/i
        : /^(?:free\s+(?:u\.?s\.?\s+)?shipping\b|(?:buy|choose|add|get)\s+(?:2|two)\s+plushies\b.*\bfree\s+(?:u\.?s\.?\s+)?shipping\b)/i;
      const shippingCopy = shippingPattern.test(custom);
      const useCustom = custom && (state.announcementAmount || state.quantityTarget) && !((state.country === 'US' || orderCurrencies[state.country]) && shippingCopy);
      node.textContent = useCustom ? format(custom,{amount:state.announcementAmount}) : state.announcement;
    });
    const config = configuration(value), summary = config.productSummary || {};
    const summaryValid = summary.country === state.country && currencyOf(config.markets?.[state.country]?.currency) === currencyOf(config.currency) && (!cart || currencyOf(cart.currency) === currencyOf(config.currency));
    element.querySelectorAll('[data-pinme-shipping-summary-primary]').forEach(node => { node.textContent = summaryValid && summary.text ? summary.text : config.labels?.checkout || defaults.checkout; });
    element.querySelectorAll('[data-pinme-shipping-summary-exclusions]').forEach(node => { node.textContent = summaryValid && summary.exclusions ? summary.exclusions+' ' : ''; node.hidden = !node.textContent; });
    return state;
  }
  function productMessage(item,value,context = {}) {
    return evaluate(null,value,{...context,product:context.product || item}).productText;
  }
  return Object.freeze({evaluate,render,productMessage});
});





